import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=cc06c09c&scoped=true&"
import script from "./Copyright.vue?vue&type=script&lang=ts&"
export * from "./Copyright.vue?vue&type=script&lang=ts&"
import style0 from "./Copyright.vue?vue&type=style&index=0&id=cc06c09c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc06c09c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VFooter})
